import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import SectionHeading from "@/components/feature/SectionHeading";

export default function CategoryNav() {
  return (
    <section className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          kicker="栏目导航"
          title="按栏目发现内容"
          desc="从游戏资讯到联动情报，从新游漫画化到版本更新，分类浏览更高效。"
          align="center"
        />
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {categories.map((c, idx) => (
            <Link
              key={c.slug}
              to={`/${c.slug}`}
              className="group relative flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 p-5 transition-all hover:-translate-y-0.5 hover:border-primary-300"
            >
              <span className={`manga-clip-both flex h-11 w-11 items-center justify-center ${c.color} text-background-50`}>
                <i className={`${c.icon} text-xl`} />
              </span>
              <h3 className="mt-4 font-heading text-lg text-foreground-950">{c.name}</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{c.desc}</p>
              <div className="mt-4 flex items-center justify-between border-t border-background-100 pt-3">
                <span className="text-xs text-foreground-500">{c.count} 篇内容</span>
                <span className="flex items-center gap-1 text-xs font-bold text-primary-600 transition-transform group-hover:translate-x-0.5">
                  前往 <i className="ri-arrow-right-line" />
                </span>
              </div>
              <span className="pointer-events-none absolute right-3 top-3 font-heading text-3xl text-background-200 transition-colors group-hover:text-primary-200">
                0{idx + 1}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}